<template>
  <div class="floating-whatsapp">
    <a 
      :href="whatsappUrl" 
      target="_blank" 
      rel="noopener noreferrer"
      class="whatsapp-link"
      :title="$t('contactUs')"
    >
      <img 
        :src="whatsappIcon" 
        alt="WhatsApp" 
        class="whatsapp-icon"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'FloatingWhatsApp',
  props: {
    phoneNumber: {
      type: String,
      default: '+509940104' // Default Saudi phone number, you can change this
    },
    message: {
      type: String,
      default: `مرحباً،

امتلك فندق أو شقة أو فيلا أو شاليه أو ملعب أو قاعة أفراح أو مزرعة أو مخيم
وأرغب في الاشتراك في منصتكم كمقدم خدمة.

أو

أرغب بحجز
الخدمة رقم:
في تاريخ:

أو

مزيد من التفاصيل عن منصتكم

                         شكراً جزيلاً!`
    }
  },
  computed: {
    whatsappIcon() {
      return require('@/assets/images/whatsapp.png');
    },
    whatsappUrl() {
      const encodedMessage = encodeURIComponent(this.message);
      return `https://wa.me/${this.phoneNumber.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
    }
  }
};
</script>

<style scoped>
.floating-whatsapp {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  animation: pulse 2s infinite;
}

.whatsapp-link {
  display: block;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.whatsapp-link:hover {
  transform: scale(1.1);
}

.whatsapp-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

.whatsapp-link:hover .whatsapp-icon {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .floating-whatsapp {
    bottom: 15px;
    right: 15px;
  }
  
  .whatsapp-icon {
    width: 50px;
    height: 50px;
  }
}

/* Hide on very small screens if needed */
@media (max-width: 320px) {
  .floating-whatsapp {
    bottom: 10px;
    right: 10px;
  }
  
  .whatsapp-icon {
    width: 45px;
    height: 45px;
  }
}
</style>
